import { useTranslation } from 'react-i18next';
import type { ClaimClosingDetailLine } from '@/utils/approval/claimClosing';
import { formatNumber, text, toNumber } from './content';

const isLine = (line: ClaimClosingDetailLine) => text(line.chk) !== '2';

/**
 * 레거시 appr_sub_view_forms_tax_cust_return_deatail_view_mstr.
 * 소계(chk=2)는 API 가 주고, 맨 끝 합계는 레거시처럼 라인의 수량·단가(원화)·청구금액(원화)을 더함
 */
const ClaimClosingDetailTable = ({
  lines,
}: {
  lines: ClaimClosingDetailLine[];
}) => {
  const { t } = useTranslation();
  const itemLines = lines.filter(isLine);
  const sum = (key: 'itemQty' | 'itemPrice' | 'supplyAmt') =>
    itemLines.reduce((acc, line) => acc + toNumber(line[key]), 0);

  return (
    <table className="detail-lines">
      <tbody>
        <tr>
          <th className="text-center">INV_NO</th>
          <th className="text-center">{t('항번')}</th>
          <th className="text-center">{t('품목')}</th>
          <th className="text-center">CURRENCY</th>
          <th className="text-center">{t('수량')}</th>
          <th className="text-center">{t('단가(원화)')}</th>
          <th className="text-center">{t('단가(통화)')}</th>
          <th className="text-center">{t('청구금액(원화)')}</th>
          <th className="text-center">{t('청구금액(통화)')}</th>
          <th className="text-center">{t('부가세(원화)')}</th>
          <th className="text-center">{t('환율')}</th>
          <th className="text-center">{t('결제방법')}</th>
        </tr>
        {lines.map((line, i) =>
          isLine(line) ? (
            <tr key={i}>
              <td className="text-center">{text(line.invNo)}</td>
              <td className="text-center">{text(line.invLno)}</td>
              <td className="text-center">{text(line.orderNo)}</td>
              <td className="text-center">{text(line.cur)}</td>
              <td className="text-right">{formatNumber(line.itemQty)}</td>
              <td className="text-right">{formatNumber(line.itemPrice)}</td>
              <td className="text-right">
                {formatNumber(line.unitPriceCurr, 2)}
              </td>
              <td className="text-right">{formatNumber(line.supplyAmt)}</td>
              <td className="text-right">{formatNumber(line.grAmtCurr, 2)}</td>
              <td className="text-right">{formatNumber(line.vatAmt)}</td>
              <td className="text-center">{formatNumber(line.exchRate, 2)}</td>
              <td className="text-center">{text(line.settlementKor)}</td>
            </tr>
          ) : (
            <tr key={i} className="bg-success">
              <td className="text-center" colSpan={4}>
                {t('소계')}
              </td>
              <td className="text-right">{formatNumber(line.itemQty)}</td>
              <td className="text-right">{formatNumber(line.itemPrice)}</td>
              <td />
              <td className="text-right">{formatNumber(line.supplyAmt)}</td>
              <td />
              <td />
              <td />
              <td />
            </tr>
          ),
        )}
        {itemLines.length > 0 && (
          <tr className="textBold">
            <td className="text-center" colSpan={4}>
              {t('합계')}
            </td>
            <td className="text-right">{formatNumber(sum('itemQty'))}</td>
            <td className="text-right">{formatNumber(sum('itemPrice'))}</td>
            <td />
            <td className="text-right">{formatNumber(sum('supplyAmt'))}</td>
            <td />
            <td />
            <td />
            <td />
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default ClaimClosingDetailTable;
